
import * as angular from "angular";
import { FileReaderService } from "@services/fileReader.service";

export class FileDragDropDirective implements angular.IDirective {

    restrict = "A";
    scope = false;

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel) => void;

    constructor(private fileReaderService: FileReaderService) {

        FileDragDropDirective.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: angular.IAttributes) => {

            $element.bind("dragover", (event) => { return this.processDragOverOrEnter(event.originalEvent as any); });
            $element.bind("dragenter", (event) => { return this.processDragOverOrEnter(event.originalEvent as any); });
            $element.bind("drop", (event) => { return this.processDragDrop(event.originalEvent as any, $scope, $attrs); });

            $scope.$on("$destroy", () => {
                $element.unbind("dragover");
                $element.unbind("dragenter");
                $element.unbind("drop");
            });
        }
    }

    private processDragDrop(event: DragEvent, $scope: angular.IScope, $attrs: angular.IAttributes) {
        if (!event) {
            return false;
        }

        event.preventDefault();

        //$scope.$apply(() => {
        //    $scope["fileDragDrop"] = event.dataTransfer.files[0];
        //});

        $scope.$eval($attrs.fileDragDrop, { file: event.dataTransfer.files[0] });

        return false;
    }

    private processDragOverOrEnter(event: DragEvent) {
        if (event != null) {
            event.preventDefault();
            event.dataTransfer.effectAllowed = "copy";
        }

        return false;
    }

    private isTypeValid(type: string, validMimeTypes: string) {
        if (!validMimeTypes || validMimeTypes.indexOf(type) >= 0) {
            return true;
        }

        return false;
    }

    private isValidSize(size: number, maxFileSize: number) {
        return (size / 1024) / 1024 < maxFileSize;
    }

    static factory(): angular.IDirectiveFactory {
        const directive = (fileReaderService: FileReaderService) => new FileDragDropDirective(fileReaderService);

        directive.$inject = ["fileReaderService"];

        return directive;
    }
}
